import { PaletteColor } from "./enums"
import { Palette } from "./types"

const hex2rgb = (hex: string) => {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)

  return { r: r, g: g, b: b, a: 1 }
}

const Color = {
  BLACK: "#000",
  DARK_GRAY: "#a9a9a9",

  STATS_BG: "#a9a9a9",

  CLOCK: "#fff",

  CASE_LIGHT: "#c97222",
  CASE_DARK: "#b87333",
  LIBRARY_BG: "#000",
  TRIGGER_LIGHT: "#000000",
  TRIGGER_DARK: "#696969",
  TAPESTRY_LIGHT: "#ffc60a",
  TAPESTRY_DARK: "#997706",

  HINT_LIGHT: "#000000",
  HINT_DARK: "#696969",
  HINT_CONTENTS: "#fff",
  HINT_DATE: "#0ff",

  COLLECTIBLE_COMMON: "#2e5984",
  COLLECTIBLE_COMMON_DARK: "#1e3f66",
  COLLECTIBLE_MYTHIC: "#2e5984",
  COLLECTIBLE_MYTHIC_DARK: "#1e3f66",

  FLOOR_TILE_BG: "#a38c6c",
  FLOOR_TILE_FG: "#ffffff",
  FLOOR_TILE_DARK_BG: "#877254",
  FLOOR_TILE_DARK_FG: "#ffffff",
  WALL_TILE_BG: "#4b3f2f",
  WALL_TILE_FG: "#ffffff",
  WALL_TILE_DARK_BG: "#2d261c",
  WALL_TILE_DARK_FG: "#ffffff",

  DANGER_TILE: "#ffbaba",
  DANGER_TILE_DARK: "#ff7b7b",
  HILITE_TILE_FG: "#ffffff",
  HILITE_TILE_BG: "#00edff",
  HILITE_TILE_DARK_FG: "#ffffff",
  HILITE_TILE_DARK_BG: "#00a6b3",

  ANY: "#ffa500",
  ANY_DARK: "#4d004c",

  ARMAMENT: "#00ffff",
  ARMAMENT_DARK: "#008b8b",
  GIZMO: "#0ff",
  GIZMO_DARK: "",
  WEARABLE: "",
  WEARABLE_DARK: "",

  KEY: "#000000",
  KEY_DARK: "#696969",

  ELIXIR: "#a741d7",
  ELIXIR_DARK: "#4f1669",

  BINDER: "#686868",
  BINDER_DARK: "#888888",

  OPTIC_YELLOW: "#ffff00",
  OPTIC_YELLOW_DARK: "#4d004c",
  OPTIC_RED: "#ff0000",
  OPTIC_RED_DARK: "#4d0000",
  OPTIC_MAGENTA: "#ff00ff",
  OPTIC_MAGENTA_DARK: "#4d004c",
  OPTIC_BLUE: "#0000ff",
  OPTIC_BLUE_DARK: "#00004d",
  OPTIC_CYAN: "#00ffffff",
  OPTIC_CYAN_DARK: "#004c4d",
  OPTIC_GREEN: "#00ff00",
  OPTIC_GREEN_DARK: "#004d00",
  OPTIC_WHITE: "#ffffff",
  OPTIC_WHITE_DARK: "#bfbfbf",
  OPTIC_BLACK: "#000000",
  OPTIC_BLACK_DARK: "#000000",

  DEVOURER: "#cc99a2",
  DEVOURER_DARK: "#997379",

  RIFT_ESSENCE: "#fb1e82",
  RIFT_ESSENCE_DARK: "#67556e",
  RIFT_PIGMENT: "#005b96",
  RIFT_PIGMENT_DARK: "#011f4b",
  RIFT_BOTH: "#246529",
  RIFT_BOTH_DARK: "#67556e",

  VOID_ESSENCE: "#fb1e82",
  VOID_ESSENCE_DARK: "#67556e",
  VOID_PIGMENT: "#005b96",
  VOID_PIGMENT_DARK: "#011f4b",
  VOID_BOTH: "#246529",
  VOID_BOTH_DARK: "#134314",

  BLADE_ESSENCE: "#fb1e82",
  BLADE_ESSENCE_DARK: "#67556e",
  BLADE_PIGMENT: "#005b96",
  BLADE_PIGMENT_DARK: "#011f4b",
  BLADE_BOTH: "#246529",
  BLADE_BOTH_DARK: "#134314",

  SPECTRE_ESSENCE: "#fb1e82",
  SPECTRE_ESSENCE_DARK: "#67556e",
  SPECTRE_PIGMENT: "#005b96",
  SPECTRE_PIGMENT_DARK: "#011f4b",
  SPECTRE_BOTH: "#246529",
  SPECTRE_BOTH_DARK: "#134314",

  REAVER_ESSENCE: "#fb1e82",
  REAVER_ESSENCE_DARK: "#67556e",
  REAVER_PIGMENT: "#005b96",
  REAVER_PIGMENT_DARK: "#011f4b",
  REAVER_BOTH: "#246529",
  REAVER_BOTH_DARK: "#134314",

  RESIDUE: "#400101",
  RESIDUE_DARK: "#2d0101",

  MESSAGE_ANY_FG: "#ffffff",
  MESSAGE_ITEM_FG: "#00ff00",
  MESSAGE_ITEM_BG: "#000000",

  PIGMENT_LIGHT_YELLOW: "#ffed00",
  PIGMENT_DARK_YELLOW: "#b3a600",
  PIGMENT_LIGHT_RED: "#ff0000",
  PIGMENT_DARK_RED: "#b30000",
  PIGMENT_LIGHT_MAGENTA: "#ff00ab",
  PIGMENT_DARK_MAGENTA: "#b30078",
  PIGMENT_LIGHT_BLUE: "#0047ab",
  PIGMENT_DARK_BLUE: "#003580",
  PIGMENT_LIGHT_CYAN: "#00edff",
  PIGMENT_DARK_CYAN: "#00a6b3",
  PIGMENT_LIGHT_GREEN: "#00b500",
  PIGMENT_DARK_GREEN: "#008000",
  PIGMENT_LIGHT_WHITE: "#ffffff",
  PIGMENT_DARK_WHITE: "#a6a6a6",
  PIGMENT_LIGHT_BLACK: "#000000",
  PIGMENT_DARK_BLACK: "#262626",

  PLAYER_NORMAL: "#ffffff",
  PORTAL_FG: "#00ffff",
  PORTAL_DARK_FG: "#a6a6a6",
  LOCKED_DOOR: "#ff0000",
  LOCKED_DOOR_DARK: "#990000",
  UNLOCKED_DOOR: "#00ff00",
  UNLOCKED_DOOR_DARK: "#009900",
}

// TODO: just YELLOW, RED, etc.
const RGBColor = {
  YELLOW: { r: 255, g: 255, b: 118 },
  RED: { r: 255, g: 0, b: 0 },
  MAGENTA: { r: 255, g: 0, b: 255 },
  BLUE: { r: 0, g: 0, b: 255 },
  CYAN: { r: 0, g: 255, b: 255 },
  GREEN: { r: 0, g: 255, b: 0 },
  WHITE: { r: 255, g: 255, b: 255 },
  BLACK: { r: 0, g: 0, b: 0 },
  GRAY: { r: 85, g: 85, b: 85 },
  MESSAGE_GOOD: { r: 0, g: 255, b: 0 },
  MESSAGE_INFO: { r: 255, g: 255, b: 255 },
  MESSAGE_WARNING: { r: 255, g: 255, b: 118 },
  MESSAGE_ERROR: { r: 255, g: 0, b: 0 },
  TAPESTRY_BACKGROUND: hex2rgb(Color.FLOOR_TILE_BG),
  TAPESTRY_BORDER: hex2rgb(Color.WALL_TILE_BG),
  TAPESTRY_NOTHING: { r: 0, g: 0, b: 0, a: 1 },
}

function initPalette(
  r: number = 0,
  g: number = 0,
  b: number = 0,
  y: number = 0,
  m: number = 0,
  c: number = 0
): Palette {
  return {
    red: r,
    green: g,
    blue: b,
    yellow: y,
    magenta: m,
    cyan: c,
  }
}

export { Color, initPalette, PaletteColor, RGBColor }
